import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=c3365534&scoped=true&"
var script = {}
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=c3365534&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3365534",
  null
  
)

export default component.exports